import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button,
  Dropdown,
  FormGroup,
  FormField,
  Input,
  Label,
  Form,
  Checkbox
} from 'semantic-ui-react'
import {
  DateTextBox
} from 'react-lib/apps/common'

const CardBillingDocumentUX = (props: any) => {
    return(
      <div
        id="CardBillingDocumentUX-div-0"
        style={{ display: "flex", flexDirection: "column" }}>
        <div
          id="CardBillingDocumentUX-div-1"
          style={{ display: props.viewMode ? "none" : "flex", padding: "10px 10px 0px 10px" , minWidth: "max-content", justifyContent: "space-between", alignItems: "flex-start" }}>
          {}
          <div
            id="CardBillingDocumentUX-div-6"
            style={{ fontSize: "1.1rem", fontWeight: "bold",display: "flex", alignItems: "center" }}>
            {props.title}
            <div
              id="CardBillingDocumentUX-div-51"
              style={{marginLeft: "15px", display: "none"}}>
              เลขที่ใบเสร็จ : 
            </div>
            <Label
              id="CardBillingDocumentUX-Label-78"
              style={{marginLeft: "5px"}}>
              {props.receiptCode}
            </Label>
          </div>
          <div
            id="CardBillingDocumentUX-div-7"
            style={{display: "flex"}}>
            {}
            <div
              id="CardBillingDocumentUX-div-110"
              style={{marginRight: "0.5rem"}}>
              {props.lockingStatusMessage}
            </div>
            <div
              id="CardBillingDocumentUX-div-111"
              style={{ fontSize: "1.1rem", fontWeight: "bold" }}>
              {props.titleDescription}
            </div>
          </div>
        </div>
        <div
          id="CardBillingDocumentUX-div-53"
          style={{padding: "0px 10px 10px 10px", display: props.viewMode ? "none" : "" }}>
          
          <hr
            id="CardBillingDocumentUX-hr-54">
          </hr>
        </div>
        <div
          id="CardBillingDocumentUX-div-85"
          style={{margin: "-0.5rem 1rem -0.15rem", display: props.showFilter? "": "none"}}>
          
          <Form
            className="size small"
            id="CardBillingDocumentUX-Form-86">
            <FormGroup
              id="CardBillingDocumentUX-FormGroup-87"
              inline={true}>
              <FormField
                id="CardBillingDocumentUX-FormField-88"
                inline={true}>
                <Checkbox
                  checked={props.medicalFeeFilter?.isDivision || false}
                  disabled={["Mode", "Item"].includes(props.orderBy || "")}
                  id="CardBillingDocumentUX-Checkbox-94"
                  label={props.languageUX === "en" ? "department" : "แผนก"}
                  name="isDivision"
                  onChange={props.onChangeFilter}
                  style={{minWidth: "max-content"}}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardBillingDocumentUX-FormField-89"
                inline={true}
                width={3}>
                <Dropdown
                  className="inline-label"
                  disabled={!props.medicalFeeFilter?.isDivision || ["Mode", "Item"].includes(props.orderBy || "")}
                  fluid={true}
                  id="CardBillingDocumentUX-Dropdown-96"
                  name="division"
                  onChange={props.onChangeFilter}
                  options={props.divisionOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.medicalFeeFilter?.division || ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardBillingDocumentUX-FormField-90"
                inline={true}>
                <Checkbox
                  checked={props.medicalFeeFilter?.isDate|| false}
                  disabled={props.orderBy === "Mode"}
                  id="CardBillingDocumentUX-Checkbox-95"
                  label={props.languageUX === "en" ? "Expense Date" : "วันที่ค่าใช้จ่าย"}
                  name="isDate"
                  onChange={props.onChangeFilter}
                  style={{minWidth: "max-content"}}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardBillingDocumentUX-FormField-91"
                inline={true}
                width={2}>
                <div
                  id="CardBillingDocumentUX-div-106"
                  style={{width: "100%"}}>
                  
                  <DateTextBox
                    disabled={!props.medicalFeeFilter?.isDate || props.orderBy === "Mode"}
                    id="CardBillingDocumentUX-DateTextBox-107"
                    onChange={(value)=>props.onChangeFilter?.(null, {name: "startDate", value})}
                    value={props.medicalFeeFilter?.startDate|| ""}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardBillingDocumentUX-FormField-92"
                inline={true}
                width={2}>
                <div
                  id="CardBillingDocumentUX-div-105"
                  style={{width: "100%"}}>
                  
                  <DateTextBox
                    disabled={!props.medicalFeeFilter?.isDate || props.orderBy === "Mode"}
                    id="CardBillingDocumentUX-DateTextBox-108"
                    onChange={(value)=>props.onChangeFilter?.(null, {name: "endDate", value})}
                    value={props.medicalFeeFilter?.endDate|| ""}>
                  </DateTextBox>
                </div>
              </FormField>
              <FormField
                id="CardBillingDocumentUX-FormField-101"
                inline={true}>
                <Checkbox
                  checked={props.medicalFeeFilter?.isEncounter|| false}
                  disabled={["Mode"].includes(props.orderBy || "")}
                  id="CardBillingDocumentUX-Checkbox-103"
                  label={props.languageUX === "en" ? "Encounter" : "เผชิญ"}
                  name="isEncounter"
                  onChange={props.onChangeFilter}
                  style={{minWidth: "max-content"}}>
                </Checkbox>
              </FormField>
              <FormField
                id="CardBillingDocumentUX-FormField-102"
                inline={true}
                width={2}>
                <Dropdown
                  className="inline-label"
                  disabled={!props.medicalFeeFilter?.isEncounter || ["Mode"].includes(props.orderBy || "")}
                  fluid={true}
                  id="CardBillingDocumentUX-Dropdown-104"
                  name="encounter"
                  onChange={props.onChangeFilter}
                  options={props.encounterNumberOptions}
                  search={true}
                  selection={true}
                  style={{width: "100%"}}
                  value={props.medicalFeeFilter?.encounter|| ""}>
                </Dropdown>
              </FormField>
              <FormField
                id="CardBillingDocumentUX-FormField-93"
                inline={true}>
                <div
                  id="CardBillingDocumentUX-div-100">
                  {props.buttonSearch}
                </div>
              </FormField>
            </FormGroup>
          </Form>
        </div>
        <div
          id="CardBillingDocumentUX-div-39"
          style={{ display: props.orderBy == "Order" ? "block" : "none", padding: "0 10px" }}>
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.invoiceItems}
            getTrProps={props.byOrderRowProps}
            headers={`${props.viewMode ? "" : "...,"}Encounter,แผนก,ชื่อรายการคำสั่ง,ประเภท,วันที่และเวลาค่าใช้จ่าย,ราคา, ส่งเบิก, absorb,เบิกเอง, เบิกไม่ได้,ส่วนลด,ผู้ป่วยชำระ, ประเภทค่าใช้จ่าย,สถานะค่าใช้จ่าย`}
            id="CardBillingDocumentUX-Table-40"
            keys={`${props.viewMode ? "": "chk,"}encounter__number,division__name,display_name,encounter__type,created,price__sum,send_claim__sum, absorb__sum,patient_claim__sum,non_claimable__sum,discount__sum,payable__sum,type__name,status__name`}
            minRows="10"
            showPagination={false}
            style={{ height: "50vh", ...(props.tableStyle || {})}}
            widths={props.viewMode ? "" : "60,100"}>
          </Table>
        </div>
        <div
          id="CardBillingDocumentUX-div-2"
          style={{ display: props.orderBy == "Mode" ? "block" : "none", padding: "0 10px" }}>
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.invoiceItems}
            getTdProps={props.onSelectedFaxClaim}
            headers={`${props.viewMode ? "": "...,"}รหัสหมวด,ชื่อหมวดค่ารักษาพยาบาล, ราคา, ส่งเบิก, absorb, เบิกเอง, เบิกไม่ได้, ส่วนลด, ผู้ป่วยชำระ`}
            id="CardBillingDocumentUX-Table-5"
            keys={`${props.viewMode ? "" : "chk,"}bill_mode__code, bill_mode__name, price__sum, send_claim__sum, absorb__sum, patient_claim__sum, non_claimable__sum, discount__sum, payable__sum`}
            minRows="10"
            showPagination={false}
            style={{ height: "50vh" }}
            widths={props.viewMode ? "" : "60,100"}>
          </Table>
        </div>
        <div
          id="CardBillingDocumentUX-div-41"
          style={{ display: props.orderBy == "Item" ? "block" : "none", padding: "0 10px" }}>
          
          <Table
            className="--rt-tbody-overflow-y-hidden"
            data={props.invoiceItems}
            getTdProps={props.onSelectedFaxClaim}
            headers={`${props.viewMode ? "": "...,"}Encounter,รหัสหมวด, รหัสค่ารักษา, ชื่อรายการค่ารักษาพยาบาล, วันที่และเวลาค่าใช้จ่าย, จำนวน, ราคาต่อหน่วย, ราคา, ส่งเบิก, absorb, เบิกเอง, เบิกไม่ได้, ส่วนลด, ผู้ป่วยชำระ, ค้างชำระ, ส่วนลดสิทธิ, รหัสส่วนลด,`}
            id="tb-billInvoiceItem"
            keys={`${props.viewMode ? "" : "chk,"}encounter__number,mode_code, code, product, createdDate, quantity, unitprice, price, send_claim, absorb, patient_claim, non_claimable, discount, pay, unpaid, drg_discount_amount, discount_code,delete`}
            minRows="10"
            showPagination={false}
            style={{ height: "50vh", ...(props.tableStyle || {})}}
            widths={props.viewMode ? "" : "60,100,100,100,140"}>
          </Table>
        </div>
        <div
          id="CardBillingDocumentUX-div-3"
          style={{ height: "8vh" , display: "none"}}>
          
          <div
            id="CardBillingDocumentUX-div-8"
            style={{"width":"100%","height":"100%","display":"grid","position":"relative","gridTemplateRows":"repeat(2, 1fr)","gridTemplateColumns":"repeat(7, 1fr)"}}>
            <div
              id="CardBillingDocumentUX-div-9"
              style={{ gridRow: "1/2", gridColumn: "1/2", padding: "5px" }}>
              
              <div
                id="CardBillingDocumentUX-div-22"
                style={{ height: "100%", display: "flex", alignItems: "flex-end" }}>
                {props.languageUX === "en" ? "Total price" : "ราคารวม"}
              </div>
            </div>
            <div
              id="CardBillingDocumentUX-div-10"
              style={{ gridRow: "1/2", gridColumn: "2/3", padding: "5px" }}>
              <div
                id="CardBillingDocumentUX-div-23"
                style={{ height: "100%", display: "flex", alignItems: "flex-end" }}>
                {props.languageUX === "en" ? "Send for disbursement" : "ส่งเบิก"}
              </div>
            </div>
            <div
              id="CardBillingDocumentUX-div-11"
              style={{ gridRow: "1/2", gridColumn: "3/4", padding: "5px" }}>
              <div
                id="CardBillingDocumentUX-div-24"
                style={{ height: "100%", display: "flex", alignItems: "flex-end" }}>
                {props.languageUX === "en" ? "absorb" : "ดูดซับ"}
              </div>
            </div>
            <div
              id="CardBillingDocumentUX-div-12"
              style={{ gridRow: "1/2", gridColumn: "4/5", padding: "5px" }}>
              <div
                id="CardBillingDocumentUX-div-25"
                style={{ height: "100%", display: "flex", alignItems: "flex-end" }}>
                {props.languageUX === "en" ? "Withdraw it yourself" : "เบิกเอง"}
              </div>
            </div>
            <div
              id="CardBillingDocumentUX-div-13"
              style={{ gridRow: "1/2", gridColumn: "5/6", padding: "5px" }}>
              <div
                id="CardBillingDocumentUX-div-26"
                style={{ height: "100%", display: "flex", alignItems: "flex-end" }}>
                {props.languageUX === "en" ? "Unable to withdraw" : "เบิกไม่ได้"}
              </div>
            </div>
            <div
              id="CardBillingDocumentUX-div-14"
              style={{ gridRow: "1/2", gridColumn: "6/7", padding: "5px" }}>
              <div
                id="CardBillingDocumentUX-div-27"
                style={{ height: "100%", display: "flex", alignItems: "flex-end" }}>
                {props.languageUX === "en" ? "discount" : "ส่วนลด"}
              </div>
            </div>
            <div
              id="CardBillingDocumentUX-div-15"
              style={{ gridRow: "1/2", gridColumn: "7/8", padding: "5px" }}>
              <div
                id="CardBillingDocumentUX-div-28"
                style={{ height: "100%", display: "flex", alignItems: "flex-end" }}>
                {props.languageUX === "en" ? "Patient payment" : "ผู้ป่วยชำระ"}
              </div>
            </div>
            <div
              id="CardBillingDocumentUX-div-16"
              style={{ textAlign: "right", gridRow: "2/3", gridColumn: "1/2", border: "solid 1px rgb(200, 200, 200, 0.5)" }}>
              {props.price_total}
            </div>
            <div
              id="CardBillingDocumentUX-div-17"
              style={{ textAlign: "right", gridRow: "2/3", gridColumn: "2/3", border: "solid 1px rgb(200, 200, 200, 0.5)" }}>
              {props.sendClaimTotal}
            </div>
            <div
              id="CardBillingDocumentUX-div-18"
              style={{ textAlign: "right", gridRow: "2/3", gridColumn: "3/4", border: "solid 1px rgb(200, 200, 200, 0.5)" }}>
              {props.absorbTotal}
            </div>
            <div
              id="CardBillingDocumentUX-div-19"
              style={{ textAlign: "right", gridRow: "2/3", gridColumn: "4/5", border: "solid 1px rgb(200, 200, 200, 0.5)" }}>
              {props.patientClaimTotal}
            </div>
            <div
              id="CardBillingDocumentUX-div-20"
              style={{ textAlign: "right", gridRow: "2/3", gridColumn: "5/6", border: "solid 1px rgb(200, 200, 200, 0.5)" }}>
              {props.nonClaimableTotal}
            </div>
            <div
              id="CardBillingDocumentUX-div-21"
              style={{ textAlign: "right", gridRow: "2/3", gridColumn: "6/7", border: "solid 1px rgb(200, 200, 200, 0.5)" }}>
              {props.discountTotal}
            </div>
            <div
              id="CardBillingDocumentUX-div-29"
              style={{ textAlign: "right", gridRow: "2/3", gridColumn: "7/8", border: "solid 1px rgb(200, 200, 200, 0.5)" }}>
              {props.payableTotal}
            </div>
          </div>
        </div>
        <div
          className="ui form"
          id="CardBillingDocumentUX-div-55"
          style={{padding: "10px 15px 5px", marginBottom: "-10px"}}>
          
          <FormGroup
            id="CardBillingDocumentUX-FormGroup-56">
            <FormField
              className="noPadding --hard"
              id="CardBillingDocumentUX-FormField-57"
              style={{ margin: "0px 10px" }}
              width={3}>
              <label
                id="CardBillingDocumentUX-label-63"
                style={{ paddingLeft: "10px" }}>
                {props.languageUX === "en" ? "Total price" : "ราคารวม"}
              </label>
              <Input
                id="CardBillingDocumentUX-Input-69"
                readOnly={true}
                size="small"
                value={props.price_total || ""}>
              </Input>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardBillingDocumentUX-FormField-58"
              style={{ margin: "0px 10px" }}
              width={3}>
              <label
                id="CardBillingDocumentUX-label-64"
                style={{ paddingLeft: "10px" }}>
                {props.languageUX === "en" ? "Claim Submit" : "ส่งเบิก"}
              </label>
              <Input
                id="CardBillingDocumentUX-Input-70"
                readOnly={true}
                size="small"
                value={props.sendClaimTotal || ""}>
              </Input>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardBillingDocumentUX-FormField-59"
              style={{ margin: "0px 10px" }}
              width={3}>
              <label
                id="CardBillingDocumentUX-label-65"
                style={{ paddingLeft: "10px" }}>
                {props.languageUX === "en" ? "Absorb" : "รพ.รับผิดชอบ"}
              </label>
              <Input
                id="CardBillingDocumentUX-Input-71"
                readOnly={true}
                size="small"
                value={props.absorbTotal || ""}>
              </Input>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardBillingDocumentUX-FormField-60"
              style={{ margin: "0px 10px" }}
              width={3}>
              <label
                id="CardBillingDocumentUX-label-66"
                style={{ paddingLeft: "10px" }}>
                {props.languageUX === "en" ? "Self-claim" : "เบิกเอง"}
              </label>
              <Input
                id="CardBillingDocumentUX-Input-72"
                readOnly={true}
                size="small"
                value={props.patientClaimTotal || ""}>
              </Input>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardBillingDocumentUX-FormField-75"
              style={{ margin: "0px 10px" }}
              width={3}>
              <label
                id="CardBillingDocumentUX-label-76"
                style={{ paddingLeft: "10px" }}>
                {props.languageUX === "en" ? "Non-claimable" : " เบิกไม่ได้"}
              </label>
              <Input
                id="CardBillingDocumentUX-Input-77"
                readOnly={true}
                value={props.nonClaimableTotal || ""}>
              </Input>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardBillingDocumentUX-FormField-61"
              style={{ margin: "0px 10px" }}
              width={3}>
              <label
                id="CardBillingDocumentUX-label-67"
                style={{ paddingLeft: "10px" }}>
                {props.languageUX === "en" ? "Discount" : "ส่วนลด"}
              </label>
              <Input
                id="CardBillingDocumentUX-Input-73"
                readOnly={true}
                size="small"
                value={props.discountTotal || ""}>
              </Input>
            </FormField>
            <FormField
              className="noPadding --hard"
              id="CardBillingDocumentUX-FormField-62"
              style={{ margin: "0px 10px" }}
              width={3}>
              <label
                id="CardBillingDocumentUX-label-68"
                style={{ paddingLeft: "10px" }}>
                {props.languageUX === "en" ? "Patient Pay" : "ผู้ป่วยชำระ"}
              </label>
              <Input
                id="CardBillingDocumentUX-Input-74"
                readOnly={true}
                size="small"
                value={props.payableTotal || ""}>
              </Input>
            </FormField>
            <FormField
              className={props.orderBy === "Item" ? "noPadding --hard" : "hidden noPadding --hard"}
              id="CardBillingDocumentUX-FormField-80"
              style={{ margin: "0px 10px" }}
              width={3}>
              <label
                id="CardBillingDocumentUX-label-81"
                style={{ paddingLeft: "10px" }}>
                {props.languageUX === "en" ? "Overdue" : "ค้างชำระ"}
              </label>
              <Input
                id="CardBillingDocumentUX-Input-82"
                readOnly={true}
                size="small"
                value={props.unpaidTotal || ""}>
              </Input>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardBillingDocumentUX-div-4"
          style={{ display: "flex", padding: "5px 10px", alignItems: "center" }}>
          
          <Button
            className={props.orderBy === "Mode" ? "active" : ""}
            color="teal"
            id="btn-billMode"
            name="Mode"
            onClick={props.onChangeOrderBy}
            size="mini"
            style={{paddingLeft: "1.2em", paddingRight: "1.2em"}}>
            {props.languageUX === "en" ? "BY MODE" : "หมวดค่ารักษาฯ"}
          </Button>
          <Button
            className={props.orderBy === "Order" ? "active" : ""}
            color="teal"
            id="btn-billOrder"
            name="Order"
            onClick={props.onChangeOrderBy}
            size="mini"
            style={{paddingLeft: "1.2em", paddingRight: "1.2em"}}>
            {props.languageUX === "en" ? "BY ORDER" : "ประเภทคำสั่ง"}
          </Button>
          <Button
            className={props.orderBy === "Item" ? "active" : ""}
            color="teal"
            id="btn-billItem"
            name="Item"
            onClick={props.onChangeOrderBy}
            size="mini"
            style={{paddingLeft: "1.2em", paddingRight: "1.2em"}}>
            {props.languageUX === "en" ? "BY ITEM" : "รายการย่อย"}
          </Button>
          <div
            id="CardBillingDocumentUX-div-84">
            {props.buttonRefresh}
          </div>
          <div
            id="CardBillingDocumentUX-div-46"
            style={{ flex: 1, ...props.displaySelect }}>
            {}
            <div
              id="CardBillingDocumentUX-div-47"
              style={{ marginLeft: "10px", display: "flex", alignItems: "center" }}>
              {props.languageUX === "en" ? "Select:" : "เลือก:"}
            </div>
            <Button
              id="btn-billAll"
              onClick={props.onClickAll}
              size="mini"
              style={{ marginLeft: "10px" }}>
              {props.languageUX === "en" ? "ALL" : "ทั้งหมด"}
            </Button>
            <Button
              id="btn-billNone"
              onClick={props.onClickNone}
              size="mini">
              {props.languageUX === "en" ? "NONE" : "ไม่มี"}
            </Button>
          </div>
          <div
            id="CardBillingDocumentUX-div-33"
            style={{ flex: 1 }}>
            
          </div>
          <div
            id="CardBillingDocumentUX-div-34"
            style={{ marginRight: "10px" , fontSize: "0.9rem", minWidth: "max-content", display: props.viewMode ? "none" : ""}}>
            {props.languageUX === "en" ? "Patient name on receipt" : "ชื่อผู้ป่วยบนใบเสร็จ"}
          </div>
          <Dropdown
            id="CardBillingDocumentUX-Dropdown-35"
            onChange={props.onChangePatient}
            options={props.patientOptions}
            selection={true}
            style={{marginRight: "10px", fontSize: "0.9rem", maxWidth: "15rem", display: props.viewMode ? "none" : ""}}
            value={props.patientValue}>
          </Dropdown>
          <Button
            color="blue"
            id="btn-bilDetailReport"
            onClick={props.onPrintReceipt}
            size="mini"
            style={{paddingLeft: "1.2em", paddingRight: "1.2em"}}>
            {props.languageUX === "en" ? "Print Outstanding payment list" : "พิมพ์รายการค้างชำระ"}
          </Button>
          <Button
            color="grey"
            disabled={props.viewMode || false}
            id="CardBillingDocumentUX-Button-79"
            onClick={props.billPaymentTransfer}
            size="mini"
            style={{ ...(props.viewMode && { display: "none" }), ...(props.orderBy !== "Order" && { display: "none" })}}>
            {props.languageUX === "en" ? "Transfer expenses" : "โอนค่าใช้จ่าย"}
          </Button>
          <Button
            color="yellow"
            disabled={props.hidebpInvoice || false}
            id="btn-bilPaymentInvoice"
            onClick={props.billPaymentInvoice}
            size="mini"
            style={{...props.hidebpInvoice && {display: "none"}, paddingLeft: "1.2em", paddingRight: "1.2em"}}>
            {props.languageUX === "en" ? "IPD Payment Notice" : "แจ้งชำระเงิน IPD"}
          </Button>
          <Button
            color="green"
            disabled={props.hidebp || false}
            id="btn-billPayment"
            onClick={props.billPayment}
            size="mini"
            style={{...props.hidebp && {display: "none"},paddingLeft: "1.2em", paddingRight: "1.2em"}}>
            {props.languageUX === "en" ? "Payment Received" : "รับชำระเงิน"}
          </Button>
        </div>
      </div>
    )
}


export default CardBillingDocumentUX

export const screenPropsDefault = {"by":"order","language":"TH","title":"MEDICAL FEE","titleDescription":"ข้อมูลรายการค่ารักษาพยาบาลรอรับชำระ"}

/* Date Time : Thu Oct 02 2025 11:21:02 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", flexDirection: \"column\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.viewMode ? \"none\" : \"flex\", padding: \"10px 10px 0px 10px\" , minWidth: \"max-content\", justifyContent: \"space-between\", alignItems: \"flex-start\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.orderBy == \"Mode\" ? \"block\" : \"none\", padding: \"0 10px\" }"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"8vh\" , display: \"none\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", padding: \"5px 10px\", alignItems: \"center\" }"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 5,
      "name": "Table",
      "parent": 2,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.invoiceItems"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.onSelectedFaxClaim"
        },
        "getTrProps": {
          "type": "code",
          "value": ""
        },
        "headers": {
          "type": "code",
          "value": "`${props.viewMode ? \"\": \"...,\"}รหัสหมวด,ชื่อหมวดค่ารักษาพยาบาล, ราคา, ส่งเบิก, absorb, เบิกเอง, เบิกไม่ได้, ส่วนลด, ผู้ป่วยชำระ`"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Table-5"
        },
        "keys": {
          "type": "code",
          "value": "`${props.viewMode ? \"\" : \"chk,\"}bill_mode__code, bill_mode__name, price__sum, send_claim__sum, absorb__sum, patient_claim__sum, non_claimable__sum, discount__sum, payable__sum`"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"50vh\" }"
        },
        "widths": {
          "type": "code",
          "value": "props.viewMode ? \"\" : \"60,100\""
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.title"
        },
        "className": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.1rem\", fontWeight: \"bold\",display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "label": "divgrid",
      "name": "div",
      "parent": 3,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{\"width\":\"100%\",\"height\":\"100%\",\"display\":\"grid\",\"position\":\"relative\",\"gridTemplateRows\":\"repeat(2, 1fr)\",\"gridTemplateColumns\":\"repeat(7, 1fr)\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"1/2\", padding: \"5px\" }"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"2/3\", padding: \"5px\" }"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"3/4\", padding: \"5px\" }"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"4/5\", padding: \"5px\" }"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"5/6\", padding: \"5px\" }"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"6/7\", padding: \"5px\" }"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 8,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{ gridRow: \"1/2\", gridColumn: \"7/8\", padding: \"5px\" }"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.price_total"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\", gridRow: \"2/3\", gridColumn: \"1/2\", border: \"solid 1px rgb(200, 200, 200, 0.5)\" }"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.sendClaimTotal"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\", gridRow: \"2/3\", gridColumn: \"2/3\", border: \"solid 1px rgb(200, 200, 200, 0.5)\" }"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.absorbTotal"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\", gridRow: \"2/3\", gridColumn: \"3/4\", border: \"solid 1px rgb(200, 200, 200, 0.5)\" }"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientClaimTotal"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-19"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\", gridRow: \"2/3\", gridColumn: \"4/5\", border: \"solid 1px rgb(200, 200, 200, 0.5)\" }"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.nonClaimableTotal"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-20"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\", gridRow: \"2/3\", gridColumn: \"5/6\", border: \"solid 1px rgb(200, 200, 200, 0.5)\" }"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 21,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.discountTotal"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-21"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\", gridRow: \"2/3\", gridColumn: \"6/7\", border: \"solid 1px rgb(200, 200, 200, 0.5)\" }"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคารวม",
          "valueEN": "Total price"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-22"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"100%\", display: \"flex\", alignItems: \"flex-end\" }"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่งเบิก",
          "valueEN": "Send for disbursement"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"100%\", display: \"flex\", alignItems: \"flex-end\" }"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": "ดูดซับ",
          "valueEN": "absorb"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"100%\", display: \"flex\", alignItems: \"flex-end\" }"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกเอง",
          "valueEN": "Withdraw it yourself"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-25"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"100%\", display: \"flex\", alignItems: \"flex-end\" }"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกไม่ได้",
          "valueEN": "Unable to withdraw"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-26"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"100%\", display: \"flex\", alignItems: \"flex-end\" }"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่วนลด",
          "valueEN": "discount"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"100%\", display: \"flex\", alignItems: \"flex-end\" }"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วยชำระ",
          "valueEN": "Patient payment"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"100%\", display: \"flex\", alignItems: \"flex-end\" }"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 8,
      "props": {
        "children": {
          "type": "code",
          "value": "props.payableTotal"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{ textAlign: \"right\", gridRow: \"2/3\", gridColumn: \"7/8\", border: \"solid 1px rgb(200, 200, 200, 0.5)\" }"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 30,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "หมวดค่ารักษาฯ",
          "valueEN": "BY MODE"
        },
        "className": {
          "type": "code",
          "value": "props.orderBy === \"Mode\" ? \"active\" : \"\""
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "btn-billMode"
        },
        "name": {
          "type": "value",
          "value": "Mode"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeOrderBy"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"1.2em\", paddingRight: \"1.2em\"}"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "ประเภทคำสั่ง",
          "valueEN": "BY ORDER"
        },
        "className": {
          "type": "code",
          "value": "props.orderBy === \"Order\" ? \"active\" : \"\""
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "btn-billOrder"
        },
        "name": {
          "type": "value",
          "value": "Order"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeOrderBy"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"1.2em\", paddingRight: \"1.2em\"}"
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 32,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการย่อย",
          "valueEN": "BY ITEM"
        },
        "className": {
          "type": "code",
          "value": "props.orderBy === \"Item\" ? \"active\" : \"\""
        },
        "color": {
          "type": "value",
          "value": "teal"
        },
        "id": {
          "type": "value",
          "value": "btn-billItem"
        },
        "name": {
          "type": "value",
          "value": "Item"
        },
        "onClick": {
          "type": "code",
          "value": "props.onChangeOrderBy"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"1.2em\", paddingRight: \"1.2em\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-33"
        },
        "style": {
          "type": "code",
          "value": "{ flex: 1 }"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อผู้ป่วยบนใบเสร็จ",
          "valueEN": "Patient name on receipt"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-34"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" , fontSize: \"0.9rem\", minWidth: \"max-content\", display: props.viewMode ? \"none\" : \"\"}"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 35,
      "name": "Dropdown",
      "parent": 4,
      "props": {
        "compact": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Dropdown-35"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangePatient"
        },
        "options": {
          "type": "code",
          "value": "props.patientOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"10px\", fontSize: \"0.9rem\", maxWidth: \"15rem\", display: props.viewMode ? \"none\" : \"\"}"
        },
        "value": {
          "type": "code",
          "value": "props.patientValue"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 36,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์รายการค้างชำระ",
          "valueEN": "Print Outstanding payment list"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "btn-bilDetailReport"
        },
        "onClick": {
          "type": "code",
          "value": "props.onPrintReceipt"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft: \"1.2em\", paddingRight: \"1.2em\"}"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 37,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "แจ้งชำระเงิน IPD",
          "valueEN": "IPD Payment Notice"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "disabled": {
          "type": "code",
          "value": "props.hidebpInvoice || false"
        },
        "id": {
          "type": "value",
          "value": "btn-bilPaymentInvoice"
        },
        "onClick": {
          "type": "code",
          "value": "props.billPaymentInvoice"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{...props.hidebpInvoice && {display: \"none\"}, paddingLeft: \"1.2em\", paddingRight: \"1.2em\"}"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "รับชำระเงิน",
          "valueEN": "Payment Received"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.hidebp || false"
        },
        "id": {
          "type": "value",
          "value": "btn-billPayment"
        },
        "onClick": {
          "type": "code",
          "value": "props.billPayment"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{...props.hidebp && {display: \"none\"},paddingLeft: \"1.2em\", paddingRight: \"1.2em\"}"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.orderBy == \"Order\" ? \"block\" : \"none\", padding: \"0 10px\" }"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 40,
      "name": "Table",
      "parent": 39,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "data": {
          "type": "code",
          "value": "props.invoiceItems"
        },
        "getTdProps": {
          "type": "code",
          "value": ""
        },
        "getTrProps": {
          "type": "code",
          "value": "props.byOrderRowProps"
        },
        "headers": {
          "type": "code",
          "value": "`${props.viewMode ? \"\" : \"...,\"}Encounter,แผนก,ชื่อรายการคำสั่ง,ประเภท,วันที่และเวลาค่าใช้จ่าย,ราคา, ส่งเบิก, absorb,เบิกเอง, เบิกไม่ได้,ส่วนลด,ผู้ป่วยชำระ, ประเภทค่าใช้จ่าย,สถานะค่าใช้จ่าย`"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Table-40"
        },
        "keys": {
          "type": "code",
          "value": "`${props.viewMode ? \"\": \"chk,\"}encounter__number,division__name,display_name,encounter__type,created,price__sum,send_claim__sum, absorb__sum,patient_claim__sum,non_claimable__sum,discount__sum,payable__sum,type__name,status__name`"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"50vh\", ...(props.tableStyle || {})}"
        },
        "widths": {
          "type": "code",
          "value": "props.viewMode ? \"\" : \"60,100\""
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.orderBy == \"Item\" ? \"block\" : \"none\", padding: \"0 10px\" }"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 42,
      "name": "Table",
      "parent": 41,
      "props": {
        "className": {
          "type": "value",
          "value": "--rt-tbody-overflow-y-hidden"
        },
        "columns": {
          "type": "code",
          "value": ""
        },
        "data": {
          "type": "code",
          "value": "props.invoiceItems"
        },
        "getTdProps": {
          "type": "code",
          "value": "props.onSelectedFaxClaim"
        },
        "getTrProps": {
          "type": "code",
          "value": ""
        },
        "headers": {
          "type": "code",
          "value": "`${props.viewMode ? \"\": \"...,\"}Encounter,รหัสหมวด, รหัสค่ารักษา, ชื่อรายการค่ารักษาพยาบาล, วันที่และเวลาค่าใช้จ่าย, จำนวน, ราคาต่อหน่วย, ราคา, ส่งเบิก, absorb, เบิกเอง, เบิกไม่ได้, ส่วนลด, ผู้ป่วยชำระ, ค้างชำระ, ส่วนลดสิทธิ, รหัสส่วนลด,`"
        },
        "id": {
          "type": "value",
          "value": "tb-billInvoiceItem"
        },
        "keys": {
          "type": "code",
          "value": "`${props.viewMode ? \"\" : \"chk,\"}encounter__number,mode_code, code, product, createdDate, quantity, unitprice, price, send_claim, absorb, patient_claim, non_claimable, discount, pay, unpaid, drg_discount_amount, discount_code,delete`"
        },
        "minRows": {
          "type": "value",
          "value": "10"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"50vh\", ...(props.tableStyle || {})}"
        },
        "widths": {
          "type": "code",
          "value": "props.viewMode ? \"\" : \"60,100,100,100,140\""
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-46"
        },
        "style": {
          "type": "code",
          "value": "{ flex: 1, ...props.displaySelect }"
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": null,
      "id": 47,
      "name": "div",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือก:",
          "valueEN": "Select:"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-47"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"10px\", display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "Button",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": "ทั้งหมด",
          "valueEN": "ALL"
        },
        "id": {
          "type": "value",
          "value": "btn-billAll"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickAll"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{ marginLeft: \"10px\" }"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 50,
      "name": "Button",
      "parent": 46,
      "props": {
        "children": {
          "type": "value",
          "value": "ไม่มี",
          "valueEN": "NONE"
        },
        "id": {
          "type": "value",
          "value": "btn-billNone"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickNone"
        },
        "size": {
          "type": "value",
          "value": "mini"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "เลขที่ใบเสร็จ : "
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"15px\", display: \"none\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"0px 10px 10px 10px\", display: props.viewMode ? \"none\" : \"\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "hr",
      "parent": 53,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-hr-54"
        }
      },
      "seq": 54,
      "void": true
    },
    {
      "from": null,
      "id": 55,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-55"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"10px 15px 5px\", marginBottom: \"-10px\"}"
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "FormGroup",
      "parent": 55,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormGroup-56"
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "FormField",
      "parent": 56,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormField-57"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 58,
      "name": "FormField",
      "parent": 56,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormField-58"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 59,
      "name": "FormField",
      "parent": 56,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormField-59"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 60,
      "name": "FormField",
      "parent": 56,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormField-60"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "FormField",
      "parent": 56,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormField-61"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 62,
      "name": "FormField",
      "parent": 56,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormField-62"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "label",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": "ราคารวม",
          "valueEN": "Total price"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-label-63"
        },
        "style": {
          "type": "code",
          "value": "{ paddingLeft: \"10px\" }"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 64,
      "name": "label",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่งเบิก",
          "valueEN": "Claim Submit"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-label-64"
        },
        "style": {
          "type": "code",
          "value": "{ paddingLeft: \"10px\" }"
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "label",
      "parent": 59,
      "props": {
        "children": {
          "type": "value",
          "value": "รพ.รับผิดชอบ",
          "valueEN": "Absorb"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-label-65"
        },
        "style": {
          "type": "code",
          "value": "{ paddingLeft: \"10px\" }"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": null,
      "id": 66,
      "name": "label",
      "parent": 60,
      "props": {
        "children": {
          "type": "value",
          "value": "เบิกเอง",
          "valueEN": "Self-claim"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-label-66"
        },
        "style": {
          "type": "code",
          "value": "{ paddingLeft: \"10px\" }"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "label",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่วนลด",
          "valueEN": "Discount"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-label-67"
        },
        "style": {
          "type": "code",
          "value": "{ paddingLeft: \"10px\" }"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "label",
      "parent": 62,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วยชำระ",
          "valueEN": "Patient Pay"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-label-68"
        },
        "style": {
          "type": "code",
          "value": "{ paddingLeft: \"10px\" }"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 69,
      "name": "Input",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Input-69"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "value": {
          "type": "code",
          "value": "props.price_total || \"\""
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 70,
      "name": "Input",
      "parent": 58,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Input-70"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "value": {
          "type": "code",
          "value": "props.sendClaimTotal || \"\""
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "Input",
      "parent": 59,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Input-71"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "value": {
          "type": "code",
          "value": "props.absorbTotal || \"\""
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 72,
      "name": "Input",
      "parent": 60,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Input-72"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "value": {
          "type": "code",
          "value": "props.patientClaimTotal || \"\""
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "Input",
      "parent": 61,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Input-73"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "value": {
          "type": "code",
          "value": "props.discountTotal || \"\""
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 74,
      "name": "Input",
      "parent": 62,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Input-74"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "value": {
          "type": "code",
          "value": "props.payableTotal || \"\""
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "FormField",
      "parent": 56,
      "props": {
        "className": {
          "type": "value",
          "value": "noPadding --hard"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormField-75"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "label",
      "parent": 75,
      "props": {
        "children": {
          "type": "value",
          "value": " เบิกไม่ได้",
          "valueEN": "Non-claimable"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-label-76"
        },
        "style": {
          "type": "code",
          "value": "{ paddingLeft: \"10px\" }"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 77,
      "name": "Input",
      "parent": 75,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Input-77"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.nonClaimableTotal || \"\""
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 78,
      "name": "Label",
      "parent": 6,
      "props": {
        "children": {
          "type": "code",
          "value": "props.receiptCode"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Label-78"
        },
        "style": {
          "type": "code",
          "value": "{marginLeft: \"5px\"}"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "Button",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "โอนค่าใช้จ่าย",
          "valueEN": "Transfer expenses"
        },
        "color": {
          "type": "value",
          "value": "grey"
        },
        "disabled": {
          "type": "code",
          "value": "props.viewMode || false"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Button-79"
        },
        "onClick": {
          "type": "code",
          "value": "props.billPaymentTransfer"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "style": {
          "type": "code",
          "value": "{ ...(props.viewMode && { display: \"none\" }), ...(props.orderBy !== \"Order\" && { display: \"none\" })}"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 80,
      "name": "FormField",
      "parent": 56,
      "props": {
        "className": {
          "type": "code",
          "value": "props.orderBy === \"Item\" ? \"noPadding --hard\" : \"hidden noPadding --hard\""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormField-80"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "label",
      "parent": 80,
      "props": {
        "children": {
          "type": "value",
          "value": "ค้างชำระ",
          "valueEN": "Overdue"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-label-81"
        },
        "style": {
          "type": "code",
          "value": "{ paddingLeft: \"10px\" }"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 82,
      "name": "Input",
      "parent": 80,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Input-82"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "value": {
          "type": "code",
          "value": "props.unpaidTotal || \"\""
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonRefresh"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-84"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-85"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"-0.5rem 1rem -0.15rem\", display: props.showFilter? \"\": \"none\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 86,
      "name": "Form",
      "parent": 85,
      "props": {
        "className": {
          "type": "value",
          "value": "size small"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Form-86"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 87,
      "name": "FormGroup",
      "parent": 86,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormGroup-87"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 88,
      "name": "FormField",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormField-88"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 89,
      "name": "FormField",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormField-89"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        },
        "width": {
          "type": "code",
          "value": "3"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 90,
      "name": "FormField",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormField-90"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 91,
      "name": "FormField",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormField-91"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 92,
      "name": "FormField",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormField-92"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 93,
      "name": "FormField",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormField-93"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 94,
      "name": "Checkbox",
      "parent": 88,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.medicalFeeFilter?.isDivision || false"
        },
        "disabled": {
          "type": "code",
          "value": "[\"Mode\", \"Item\"].includes(props.orderBy || \"\")"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Checkbox-94"
        },
        "label": {
          "type": "value",
          "value": "แผนก",
          "valueEN": "department"
        },
        "name": {
          "type": "value",
          "value": "isDivision"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 95,
      "name": "Checkbox",
      "parent": 90,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.medicalFeeFilter?.isDate|| false"
        },
        "disabled": {
          "type": "code",
          "value": "props.orderBy === \"Mode\""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Checkbox-95"
        },
        "label": {
          "type": "value",
          "value": "วันที่ค่าใช้จ่าย",
          "valueEN": "Expense Date"
        },
        "name": {
          "type": "value",
          "value": "isDate"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 96,
      "name": "Dropdown",
      "parent": 89,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "disabled": {
          "type": "code",
          "value": "!props.medicalFeeFilter?.isDivision || [\"Mode\", \"Item\"].includes(props.orderBy || \"\")"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Dropdown-96"
        },
        "name": {
          "type": "value",
          "value": "division"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.divisionOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.medicalFeeFilter?.division || \"\""
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "div",
      "parent": 93,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSearch"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-100"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "FormField",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormField-101"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "FormField",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-FormField-102"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "width": {
          "type": "code",
          "value": "2"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "Checkbox",
      "parent": 101,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.medicalFeeFilter?.isEncounter|| false"
        },
        "disabled": {
          "type": "code",
          "value": "[\"Mode\"].includes(props.orderBy || \"\")"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Checkbox-103"
        },
        "label": {
          "type": "value",
          "value": "เผชิญ",
          "valueEN": "Encounter"
        },
        "name": {
          "type": "value",
          "value": "isEncounter"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "style": {
          "type": "code",
          "value": "{minWidth: \"max-content\"}"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 104,
      "name": "Dropdown",
      "parent": 102,
      "props": {
        "className": {
          "type": "value",
          "value": "inline-label"
        },
        "defaultValue": {
          "type": "value",
          "value": ""
        },
        "disabled": {
          "type": "code",
          "value": "!props.medicalFeeFilter?.isEncounter || [\"Mode\"].includes(props.orderBy || \"\")"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-Dropdown-104"
        },
        "name": {
          "type": "value",
          "value": "encounter"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeFilter"
        },
        "options": {
          "type": "code",
          "value": "props.encounterNumberOptions"
        },
        "placeholder": {
          "type": "value",
          "value": ""
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.medicalFeeFilter?.encounter|| \"\""
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": null,
      "id": 105,
      "name": "div",
      "parent": 92,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-105"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "div",
      "parent": 91,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-106"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 107,
      "name": "DateTextBox",
      "parent": 106,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.medicalFeeFilter?.isDate || props.orderBy === \"Mode\""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-DateTextBox-107"
        },
        "onChange": {
          "type": "code",
          "value": "(value)=>props.onChangeFilter?.(null, {name: \"startDate\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.medicalFeeFilter?.startDate|| \"\""
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "react-lib/apps/common",
      "id": 108,
      "name": "DateTextBox",
      "parent": 105,
      "props": {
        "disabled": {
          "type": "code",
          "value": "!props.medicalFeeFilter?.isDate || props.orderBy === \"Mode\""
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-DateTextBox-108"
        },
        "onChange": {
          "type": "code",
          "value": "(value)=>props.onChangeFilter?.(null, {name: \"endDate\", value})"
        },
        "value": {
          "type": "code",
          "value": "props.medicalFeeFilter?.endDate|| \"\""
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 110,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.lockingStatusMessage"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-110"
        },
        "style": {
          "type": "code",
          "value": "{marginRight: \"0.5rem\"}"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": null,
      "id": 111,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "code",
          "value": "props.titleDescription"
        },
        "id": {
          "type": "value",
          "value": "CardBillingDocumentUX-div-111"
        },
        "style": {
          "type": "code",
          "value": "{ fontSize: \"1.1rem\", fontWeight: \"bold\" }"
        }
      },
      "seq": 111,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardBillingDocumentUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "by": "order",
    "language": "TH",
    "title": "MEDICAL FEE",
    "titleDescription": "ข้อมูลรายการค่ารักษาพยาบาลรอรับชำระ"
  },
  "width": 80
}

*********************************************************************************** */
